import React, { useState, useEffect, useCallback } from 'react';
import { FaGoodreads } from 'react-icons/fa';
import { useBookData } from '../data/books';
import Shelf from '../components/bookshelf/Shelf';
import '../components/bookshelf/bookshelf.css';

const GOODREADS_PROFILE = 'https://www.goodreads.com/user/show/125421519-vamsi-saladi';

function Bookshelf() {
  const { currentlyReading, reads2026, reads2025 } = useBookData();
  const [openId, setOpenId] = useState(null);

  const toggle = useCallback((book) => {
    const id = book.goodreadsUrl || book.title;
    setOpenId((current) => (current === id ? null : id));
  }, []);

  // Put the book back when clicking elsewhere or pressing Escape.
  useEffect(() => {
    if (!openId) return undefined;
    const onPointerDown = (e) => {
      if (!e.target.closest || !e.target.closest('.book-slot')) setOpenId(null);
    };
    const onKeyDown = (e) => {
      if (e.key === 'Escape') setOpenId(null);
    };
    document.addEventListener('pointerdown', onPointerDown);
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('pointerdown', onPointerDown);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [openId]);

  if (!currentlyReading || !reads2025) {
    return <div>Loading books...</div>;
  }

  return (
    <div className="page bookshelf-page">
      <header className="bookshelf-header">
        <div>
          <h1 className="page-title">Bookshelf</h1>
          <p className="page-lead">Pull a book off the shelf to see what I thought of it.</p>
        </div>
        <a
          className="bookshelf-goodreads"
          href={GOODREADS_PROFILE}
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaGoodreads size={18} aria-hidden="true" />
          <span>Follow me on Goodreads</span>
        </a>
      </header>

      <div className="bookcase">
        <Shelf
          label="Reading now"
          books={currentlyReading}
          mode="face"
          variant="current"
          openId={openId}
          onToggle={toggle}
          emptyText="Between books at the moment."
        />
        <Shelf
          label="2026"
          books={reads2026}
          mode="spine"
          variant="year"
          openId={openId}
          onToggle={toggle}
          emptyText="Nothing finished yet this year."
        />
        <Shelf
          label="2025"
          books={reads2025}
          mode="spine"
          variant="past"
          openId={openId}
          onToggle={toggle}
          emptyText="No books recorded for this year."
        />
      </div>
    </div>
  );
}

export default Bookshelf;
